module.exports = __webpack_public_path__ + "img/banner-aile-temelli-arabuluculuk.a97b75be.png";